

















































import { Component, Mixins, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import {
  IEditableFormatQuestionnaireSubmission,
  IEditableFormatQuestionnaireSubmissionEndpoint,
  IEditableFormatQuestionnaireSubmissionAttachmentResource,
  IEditableFormatQuestionnaireSubmissionPseudonymization,
} from "../../../../../../domain/editableFormat";
import FormatQuestionnaireSubmissionEndpointPropertyEditor from "./FormatQuestionnaireSubmissionEndpointPropertyEditor.vue";
import FormatQuestionnaireSubmissionAttachmentResourcePropertyEditor from "./FormatQuestionnaireSubmissionAttachmentResourcePropertyEditor.vue";
import FormatQuestionnaireSubmissionPseudonymizationPropertyEditor from "./FormatQuestionnaireSubmissionPseudonymizationPropertyEditor.vue";

@Component({
  components: {
    FormatQuestionnaireSubmissionEndpointPropertyEditor,
    FormatQuestionnaireSubmissionAttachmentResourcePropertyEditor,
    FormatQuestionnaireSubmissionPseudonymizationPropertyEditor,
  },
})
export default class FormatQuestionnaireSubmissionPropertyEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IEditableFormatQuestionnaireSubmission) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IEditableFormatQuestionnaireSubmission) => T, defaultValue: T) => T;

  get display(): string {
    return this.readPropertyOrDefault(s => s.display, "");
  }

  set display(value: string) {
    this.writePropertyWhenValid(s => s.display = value);
  }

  get endpoints(): IEditableFormatQuestionnaireSubmissionEndpoint[] {
    return this.readPropertyOrDefault(s => s.endpoints, []);
  }

  set endpoints(value: IEditableFormatQuestionnaireSubmissionEndpoint[]) {
    this.writePropertyWhenValid(s => s.endpoints = value);
  }

  get attachmentResources(): IEditableFormatQuestionnaireSubmissionAttachmentResource[] {
    return this.readPropertyOrDefault(s => s.attachmentResources, []);
  }

  set attachmentResources(value: IEditableFormatQuestionnaireSubmissionAttachmentResource[]) {
    this.writePropertyWhenValid(s => s.attachmentResources = value);
  }

  get pseudonymizations(): IEditableFormatQuestionnaireSubmissionPseudonymization[] {
    return this.readPropertyOrDefault(s => s.pseudonymizations, []);
  }

  set pseudonymizations(value: IEditableFormatQuestionnaireSubmissionPseudonymization[]) {
    this.writePropertyWhenValid(s => s.pseudonymizations = value);
  }

  addEndpoint() {
    this.writePropertyWhenValid(s => s.endpoints = this.updateObject(s.endpoints, c => c.push(this.createEmptyEndpoint())));
  }

  private createEmptyEndpoint(): IEditableFormatQuestionnaireSubmissionEndpoint {
    return {
      valueUrl: "",
    };
  }

  updateEndpoint(index: number, item: IEditableFormatQuestionnaireSubmissionEndpoint) {
    this.writePropertyWhenValid(s => s.endpoints = this.updateObject(s.endpoints, c => c[index] = item));
  }

  deleteEndpoint(index: number) {
    this.writePropertyWhenValid(s => s.endpoints = this.updateObject(s.endpoints, c => c.splice(index, 1)));
  }

  addAttachmentResource() {
    this.writePropertyWhenValid(s => s.attachmentResources = this.updateObject(s.attachmentResources, c => c.push(this.createEmptyAttachmentResource())));
  }

  private createEmptyAttachmentResource(): IEditableFormatQuestionnaireSubmissionAttachmentResource {
    return {
      description: "",
      expression: "",
    };
  }

  updateAttachmentResource(index: number, item: IEditableFormatQuestionnaireSubmissionAttachmentResource) {
    this.writePropertyWhenValid(s => s.attachmentResources = this.updateObject(s.attachmentResources, c => c[index] = item));
  }

  deleteAttachmentResource(index: number) {
    this.writePropertyWhenValid(s => s.attachmentResources = this.updateObject(s.attachmentResources, c => c.splice(index, 1)));
  }

  addPseudonymization() {
    this.writePropertyWhenValid(s => s.pseudonymizations = this.updateObject(s.pseudonymizations, c => c.push(this.createEmptyPseudonymization())));
  }

  private createEmptyPseudonymization(): IEditableFormatQuestionnaireSubmissionPseudonymization {
    return {
      marker: true,
      format: "masked",
      target: "",
      type: "string",
    };
  }

  updatePseudonymization(index: number, item: IEditableFormatQuestionnaireSubmissionPseudonymization) {
    this.writePropertyWhenValid(s => s.pseudonymizations = this.updateObject(s.pseudonymizations, c => c[index] = item));
  }

  deletePseudonymization(index: number) {
    this.writePropertyWhenValid(s => s.pseudonymizations = this.updateObject(s.pseudonymizations, c => c.splice(index, 1)));
  }

  private updateObject<T>(object: T, update: (clone: T) => void): T {
    const clone = JSON.parse(JSON.stringify(object)) as T;
    update(clone);
    return clone;
  }

  @Emit()
  deleteProperty() {}
}
